import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';

import { CoreModule } from '../core/core.module';
import { SharedModule } from '../shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CurrencyMaskModule } from 'ng2-currency-mask';

import { ProjectModule } from '../project/project.module';

import { FiscalModule } from '../fiscal/fiscal.module';
import {PrrSummaryComponent} from './summary/prr/summary/summary.component';
import {PrrApplicationComponent} from './prr-application/prr-application.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    ProjectModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    CurrencyMaskModule,
    FiscalModule,
    NgMultiSelectDropDownModule
  ],
  declarations: [
    PrrSummaryComponent,
    PrrApplicationComponent
  ],
  entryComponents: [
  ],
  exports: [
    PrrSummaryComponent,
    PrrApplicationComponent
  ],
  providers: []
})
export class PrrModule {}
